import { gql } from "@apollo/client";

export const GET_ULTIMO_PERIODO_CERRADO = gql`
query ultimoPeriodoCerrado {
    ultimoPeriodoCerrado { 
        idPeriodo
        mes
        ano
        fechaDesde
        fechaHasta
    }
}`;

export const adaptUltimoPeriodoCerrado = (data) => {

    const {
        idPeriodo,
        mes,
        ano,
        fechaDesde,
        fechaHasta,
    } = data?.ultimoPeriodoCerrado || {};

    return {
        idPeriodo: idPeriodo || null,
        month: mes || null,
        year: ano || null,
        dateFrom: fechaDesde || null,
        dateTo: fechaHasta || null
    };
}